import Box from '@redbubble/design-system/src/Box';
import Skeleton from '@redbubble/design-system/src/Skeleton';
import styles from './Bubble.module.scss';

export const BubbleLoading: React.FC = () => {
  return (
    <Box className={styles.skeletonPill}>
      <Skeleton
        animated
        width={130}
        height={34}
        data-testid="bubble-skeleton"
      />
    </Box>
  );
};
